import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import LEGAL from './legal';
import OFFER from './offer';
import ARTICLE from './article';
import CUSTOM from './custom';
import COLLECTION from './collection';
import LANDING from './landing';
import CHRISTMAS from './christmas';
import LOOKBOOK from './lookbook';
import HOME from './home';
import GENERIC from './generic';
import STORE_LOCATOR from './store-locator';
import CATALOG_ORDER from './catalog_order';
import NEWSLETTER from './newsletter';
import NORESULT from './noresult';
export default [LEGAL, OFFER, ARTICLE, CATALOG_ORDER, CHRISTMAS, COLLECTION, CUSTOM, GENERIC, HOME, LANDING, LEGAL, LOOKBOOK, OFFER, STORE_LOCATOR, NEWSLETTER, NORESULT];